import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Symposia = () => {
  return (
    <React.Fragment>
      <SEO title="Symposia | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Symposia"
        content="The Conference"
        contentTwo="Symposia"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <h3>Call for Symposia / Workshop</h3>
          In the symposia and/or workshop, you can present your research work,
          communicate with other scholars, obtain the information about the
          current status of the study and look into the future of swarm
          intelligence related area. Besides, you can listen to the lectures of
          the ICSI 2022, which may give you some inspiration for your own study.
          <p align="justify">
            Prospective organizers of symposia or workshop should submit
            proposals indicating:
          </p>
          <p align="left">
            * Title of the symposia or workshop.
            <br />
            * Rationale of the need for the symposia or workshop at ICSI.
            <br />
            * Short biography and recent photo of the organizers.
            <br />
          </p>
          <p align="justify">
            Proposals are due on or before Jan 28, 2022 and should be sent via
            e-mail (in either pdf or plain ASCII text form) to ICSI 2022
            secretariat at{" "}
            <a href="mailto: icsi2022@iasei.org">icsi2022@iasei.org</a>
          </p>
        </div>
        
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Symposia;
